import * as Joi from "joi";

const stringWithNumbersOnlyRegEx = /^\d+$/; // @ref https://github.com/sideway/joi/issues/1157#issuecomment-293538673

export const SignUpSchema = Joi.object({
  email: Joi.string().trim().max(100).required().messages({
    "any.required": "Email address is required.",
    "string.base": "Email address is required.",
    "string.empty": "Email address is required.",
    "string.min": "Email address can be at most 100 characters only.",
    "string.max": "Email address can be at most 100 characters only.",
  }),
  phoneNumber: Joi.string()
    .trim()
    .min(1)
    .max(30)
    .regex(stringWithNumbersOnlyRegEx)
    .required()
    .messages({
      "any.required": "Phone number is required.",
      "string.base": "Phone number is required.",
      "string.empty": "Phone number is required.",
      "string.pattern.base": "Please input valid phone number.",
      "string.min": "Phone number can be at most 30 characters only.",
      "string.max": "Phone number can be at most 30 characters only.",
    }),
  username: Joi.string().trim().min(1).max(50).required().messages({
    "any.required": "Username is required.",
    "string.base": "Username is required.",
    "string.empty": "Username is required.",
    "string.min": "Username can be at most 50 characters only.",
    "string.max": "Username can be at most 50 characters only.",
  }),
  password: Joi.string()
    .min(8)
    .max(22)
    .pattern(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{7,}$/)
    .required()
    .messages({
      "any.required": "Password is required.",
      "string.base": "Password is required.",
      "string.pattern.base":
        "Password must be at least 8 characters and includes at least one upper and lower case letter, number/s, and special character.",
      "string.empty": "Password is required.",
      "string.min": "Password must have 8 to 22 characters only.",
      "string.max": "Password must have 8 to 22 characters only.",
    }),
  confirmPassword: Joi.any().valid(Joi.ref("password")).messages({
    "any.only": "Passwords do not match.",
  }),
  firstName: Joi.any(),
  middleName: Joi.any(),
  lastName: Joi.any(),
  pin: Joi.any(),
});
